const specialKeys = {
    Letter: /^[a-z]$/,
    LetterOrNumber: /^[a-z0-9]$/,
    Plus: /^\+$/,
    Space: /^ $/,
};
const testHotkeyMatch = (pressedKeys, tree, hotkey) => {
    const supposedKeys = hotkey.hotkey.split("+");
    const doKeysMatch = supposedKeys.every((key) => key in specialKeys
        ? [...pressedKeys].some((pressedKey) => specialKeys[key].test(pressedKey))
        : pressedKeys.has(key));
    const isEnabled = !hotkey.isEnabled || hotkey.isEnabled(tree);
    const equalCounts = pressedKeys.size === supposedKeys.length;
    return doKeysMatch && isEnabled && equalCounts;
};
const findHotkeyMatch = (pressedKeys, tree, config1, config2) => {
    var _a;
    return (_a = Object.entries(Object.assign(Object.assign({}, config1), config2)).find(([, hotkey]) => testHotkeyMatch(pressedKeys, tree, hotkey))) === null || _a === void 0 ? void 0 : _a[0];
};
export const hotkeysCoreFeature = {
    key: "hotkeys-core",
    onTreeMount: (tree, element) => {
        const data = tree.getDataRef();
        const keydown = (e) => {
            var _a, _b, _c, _d;
            var _e;
            (_a = (_e = data.current).pressedKeys) !== null && _a !== void 0 ? _a : (_e.pressedKeys = new Set());
            const newMatch = !data.current.pressedKeys.has(e.key);
            data.current.pressedKeys.add(e.key);
            console.log("HOTKEYS", data.current.pressedKeys);
            const hotkeyName = findHotkeyMatch(data.current.pressedKeys, tree, tree.getHotkeyPresets(), tree.getConfig().hotkeys);
            if (!hotkeyName)
                return;
            const hotkeyConfig = Object.assign(Object.assign({}, tree.getHotkeyPresets()[hotkeyName]), (_b = tree.getConfig().hotkeys) === null || _b === void 0 ? void 0 : _b[hotkeyName]);
            if (!hotkeyConfig)
                return;
            if (!hotkeyConfig.allowWhenInputFocused &&
                e.target instanceof HTMLInputElement)
                return;
            if (!hotkeyConfig.canRepeat && !newMatch)
                return;
            if (hotkeyConfig.preventDefault)
                e.preventDefault();
            hotkeyConfig.handler(e, tree);
            (_d = (_c = tree.getConfig()).onTreeHotkey) === null || _d === void 0 ? void 0 : _d.call(_c, hotkeyName, e);
        };
        const keyup = (e) => {
            var _a;
            var _b;
            (_a = (_b = data.current).pressedKeys) !== null && _a !== void 0 ? _a : (_b.pressedKeys = new Set());
            data.current.pressedKeys.delete(e.key);
        };
        // keyup is registered on document, because some hotkeys shift
        // the focus away from the tree (i.e. search)
        // and then we wouldn't get the keyup event anymore
        element.addEventListener("keydown", keydown);
        document.addEventListener("keyup", keyup);
        data.current.keydownHandler = keydown;
        data.current.keyupHandler = keyup;
    },
    onTreeUnmount: (tree, element) => {
        const data = tree.getDataRef();
        if (data.current.keyupHandler) {
            document.removeEventListener("keyup", data.current.keyupHandler);
            delete data.current.keyupHandler;
        }
        if (data.current.keydownHandler) {
            element.removeEventListener("keydown", data.current.keydownHandler);
            delete data.current.keydownHandler;
        }
    },
};
